import type { Infer } from 'superstruct';
import { object, optional, string } from 'superstruct';

// Merchant Center
export const GoogleAdsMerchantCenter = object({
	merchant_center_id: optional(string()),
});

export type GoogleAdsMerchantCenter = Infer<typeof GoogleAdsMerchantCenter>;

// Product Link
export const GoogleAdsProductLink = object({
	resource_name: optional(string()),
	product_link_id: optional(string()),
	type: optional(string()),
	merchant_center: optional(GoogleAdsMerchantCenter),
});

export type GoogleAdsProductLink = Infer<typeof GoogleAdsProductLink>;

// Customer
export const GoogleAdsCustomer = object({
	resource_name: optional(string()),
	id: optional(string()),
	descriptive_name: optional(string()),
});

export type GoogleAdsCustomer = Infer<typeof GoogleAdsCustomer>;

// Merchant Center Feed
export const GoogleAdsMerchantCenterFeed = object({
	customer: optional(GoogleAdsCustomer),
	product_link: optional(GoogleAdsProductLink),
});

export type GoogleAdsMerchantCenterFeed = Infer<
	typeof GoogleAdsMerchantCenterFeed
>;
